import { DKcourts } from '@debbie/common/dist/court/countries/denmark.js';
import { GLcourts } from '@debbie/common/dist/court/countries/greenland.js';
import { CountryCode, addressToString } from '@debbie/common/dist/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Info } from '../Icons/index.js';
import { Modal, SearchInput, Table } from '../index.js';
const CourtSearch = (props) => {
    const lang = useSelector((s) => s.lang);
    const [courtOverviewOpen, setCourtOverviewOpen] = useState(false);
    const courts = props.country == CountryCode.DK ? DKcourts : GLcourts;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null,
            "Retskreds",
            ' ',
            React.createElement(Info, { style: { cursor: 'pointer', float: 'right' }, onClick: () => setCourtOverviewOpen(!courtOverviewOpen) })),
        courtOverviewOpen && (React.createElement(Modal, { onToggle: () => setCourtOverviewOpen(!courtOverviewOpen), header: "Overblik over retskredsene", maxWidth: "1800px" },
            React.createElement(Table, { zebra: true },
                React.createElement("tr", null,
                    React.createElement("th", null, "ID"),
                    React.createElement("th", null, "Navn"),
                    React.createElement("th", null, "Konto"),
                    React.createElement("th", null, "Adresse"),
                    React.createElement("th", null, "E-mail"),
                    React.createElement("th", null, "E-mail til indlevering af betalingsp\u00E5krav"),
                    React.createElement("th", null, "E-mail til revideret betalingsp\u00E5krav"),
                    React.createElement("th", null, "E-mail til indlevering af fogedrekvisitioner"),
                    React.createElement("th", null, "Telefonnr.")),
                courts.map((c) => (React.createElement("tr", { key: c.id },
                    React.createElement("td", null, c.id),
                    React.createElement("td", null, c.name),
                    React.createElement("td", null,
                        c.registrationnumber,
                        " ",
                        c.accountnumber),
                    React.createElement("td", null, addressToString(c)),
                    React.createElement("td", null, c.email),
                    React.createElement("td", null, c.emailFogedretIndleveringBPK),
                    React.createElement("td", null, c.emailFogedretRevideretBPK),
                    React.createElement("td", null, c.emailFogedretIndleveringFogedrekvisition),
                    React.createElement("td", null, c.phone))))))),
        React.createElement(SearchInput, { placeholder: lang.documents.selectCourt, searchAll: (q) => {
                return courts
                    .filter((c) => `${c.name}${c.address}${c.city}${c.email}${c.phone}`
                    .toLowerCase()
                    .indexOf(q.toLowerCase()) !== -1)
                    .map((c) => ({
                    key: c.id,
                    heading: c.name,
                    subheading: addressToString(c),
                    returnData: c,
                }));
            }, static: props.courtId && courts.find((c) => c.courtId == props.courtId)?.name, onRemoveStatic: () => props.onSelect(null), onSelect: (court) => props.onSelect(court.courtId), searchDelay: 0, forceOpen: true })));
};
export default CourtSearch;
//# sourceMappingURL=CourtSearch.js.map